import * as Sentry from '@sentry/react';
import { REACT_APP_WX_COPILOT_URL } from 'runtimeEnvVars';

export function reportWxCopilotFailure(
  operation: 'load' | 'config' | 'render' | 'update' | 'destroy',
  error?: unknown,
): void {
  const version =
    /\/wx-copilot\/(v\d+)\//.exec(REACT_APP_WX_COPILOT_URL)?.[1] ?? 'custom';
  const errorType =
    error instanceof TypeError
      ? 'TypeError'
      : error instanceof RangeError
        ? 'RangeError'
        : error instanceof Error
          ? 'Error'
          : 'unknown';
  // Never capture the vendor exception: its message, cause and fields can hold
  // auth, props or applicant context. Also exclude inherited scope payloads.
  Sentry.withScope(scope => {
    scope.clear();
    scope.addEventProcessor(event => ({
      event_id: event.event_id,
      timestamp: event.timestamp,
      platform: event.platform,
      release: event.release,
      environment: event.environment,
      exception: event.exception,
      contexts: { trace: event.contexts?.trace },
      level: 'error',
      tags: {
        widget: 'wx-copilot',
        version,
        operation,
        reason: operation === 'load' ? 'script_error' : 'exception',
        error_type: errorType,
      },
      fingerprint: ['cue_widget_failed', operation, version, errorType],
    }));
    Sentry.captureException(new Error('cue_widget_failed'));
  });
}
